function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 388",
    d: "M122.253 78.4a1.86 1.86 0 0 0-1.854 1.854v13.209a1.629 1.629 0 0 0 1.622 1.622h15.756a1.629 1.629 0 0 0 1.622-1.622V82.8a1.629 1.629 0 0 0-1.622-1.622h-1.159v-2.313a.482.482 0 0 0-.463-.463zm0 .927h13.439v1.854h-13.439a.927.927 0 0 1 0-1.853zm-.927 2.527a1.839 1.839 0 0 0 .927.253h15.524a.684.684 0 0 1 .7.7v2.78h-6.72a1.166 1.166 0 0 0-1.159 1.159v2.78a1.166 1.166 0 0 0 1.159 1.159h6.72v2.78a.684.684 0 0 1-.7.7h-15.756a.684.684 0 0 1-.7-.7zm10.427 4.656h6.72v3.244h-6.72a.222.222 0 0 1-.232-.232v-2.78a.222.222 0 0 1 .232-.232z",
    transform: "translate(-117.898 -74.902)",
    style: {
      fill: "#6c7b8b",
      stroke: "#6c7b8b",
      strokeWidth: ".5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.6e4a00a5d854dd63a00c6f4617d4f220.svg";
export { ForwardRef as ReactComponent };